import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Zap, PlayCircle } from 'lucide-react';

const CtaSection = ({ onActionClick }) => {
  
  const handleNavigation = (url, ariaLabel) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="cta" className="py-20 bg-gradient-to-br from-primary/90 via-primary to-orange-600 text-primary-foreground">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.h2 
          className="text-4xl md:text-5xl font-bold mb-6 font-heading"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          Start Building with Webfiny Today
        </motion.h2>
        <motion.p 
          className="text-xl text-primary-foreground/80 mb-10 max-w-2xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          Unlock powerful PDF functionalities for your applications. Explore our API, test it in the playground, and start your free trial.
        </motion.p>
        <motion.div 
          className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <Button 
            size="lg" 
            onClick={() => handleNavigation('https://crafter.webfiny.com/', 'Start Free Now with WebFiny Crafter')}
            className="bg-background text-primary hover:bg-background/90 shadow-lg w-full sm:w-auto pulse-glow-white"
            aria-label="Start Free Now with WebFiny Crafter in a new tab"
          >
            <Zap className="mr-2 h-5 w-5" />
            Start Free Now
          </Button>
          <Button 
            size="lg" 
            variant="outline" 
            onClick={() => handleNavigation('https://apidocs.webfiny.com/', 'Launch WebFiny API Playground')}
            className="text-primary-foreground border-primary-foreground/50 hover:bg-primary-foreground/10 hover:text-primary-foreground w-full sm:w-auto"
            aria-label="Launch WebFiny API Playground in a new tab"
          >
            <PlayCircle className="mr-2 h-5 w-5" />
            Launch API Playground
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default CtaSection;